<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25">
      <div class="d-sm-flex align-items-center">
        <router-link class="btn btn-primary" to="/ajouter-place">
          <i class="fa fa-plus-circle"></i>
          Ajouter place
        </router-link>
      </div>
      <div class="d-flex align-items-center">
        <form class="search-box position-relative me-15">
          <input type="text" name="mot" v-model="searchTerm" @keyup="rechercher"
            class="form-control shadow-none text-black rounded-0 border-0" placeholder="Rechercher une place" />
          <button type="submit" class="bg-transparent text-primary transition p-0 border-0">
            <i class="flaticon-search-interface-symbol"></i>
          </button>
        </form>
      </div>
    </div>


    <div class="card-body p-15 p-sm-20 p-md-25 pb-0">
      <div class="row d-flex">

        <div class="col-md-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Marché <span class="text-danger">*</span>
            </label>
            <Field v-model="_marche" name="marche" v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :options="marchesOptions" :preserve-search="true"
                :multiple="false" :searchable="true" placeholder="Sélectionner le marché" label="label"
                track-by="label" />
            </Field>
            <ErrorMessage name="marche" class="text-danger" />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Type <span class="text-danger">*</span>
            </label>
            <Field v-model="_type" name="type" v-slot="{ field }">
              <Multiselect v-model="field.value" v-bind="field" :options="typesOptions" :preserve-search="true"
                :multiple="false" :searchable="true" placeholder="Sélectionner le type" label="label"
                track-by="label" />
            </Field>
            <ErrorMessage name="type" class="text-danger" />
          </div>
        </div>

        <div class="col-md-3">
          <div class="form-group mb-15 mb-sm-20 mb-md-25">
            <label class="d-block text-black fw-semibold mb-10">
              Statut <span class="text-danger">*</span>
            </label>
            <Field name="statut" v-model="_statut" type="text" v-slot="{ field }">
              <Multiselect :searchable="true" :options="[
                { value: 0, label: 'Non occupée' },
                { value: 1, label: 'Occupée' }
              ]" v-model="field.value" v-bind="field" placeholder="Sélectionner le statut" />
            </Field>
          </div>
        </div>

      </div>
    </div>

    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Code
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Loyer base
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Marché
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Type
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                Statut
              </th>

              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0  pe-0">ACTIONS
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(place, index) in places" :key="index">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ place.code }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ place.loyerBase }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ place?.marche?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ place?.type?.type?.libelle }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span :class="['badge', place?.statut === 0 ? 'bg-success' : 'bg-danger']">
                  {{ place?.statut === 0 ? 'Non occupée' : 'Occupée' }}
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary pe-0">
                <div class="dropdown">
                  <button class="btn btn-sm btn-primary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    Actions
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <router-link :to="{ name: 'ViewPlacePage', params: { id: place.id } }"
                        class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-eyes lh-1 me-8 position-relative top-1"></i>Détail
                        </router-link>
                    </li>
                    <li>
                      <router-link :to="{ name: 'EditPlacePage', params: { id: place.id } }"
                        class="dropdown-item d-flex align-items-center"><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"></i>Modifier
                        </router-link>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);"
                        @click="suppression(place.id, places, 'places', `place n° ${place.code}`)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        Supprimer
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center">
        <PaginationComponent :page="page" :totalPages="totalPages" :totalElements="totalElements" :limit="limit"
          @paginate="handlePaginate" />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, watch } from "vue";
import Swal from "sweetalert2";
import { Place } from "@/models/Place";
import ApiService from "@/services/ApiService";
import { suppression, error } from "@/utils/utils";
import PaginationComponent from '@/components/Utilities/Pagination.vue';
import JwtService from "@/services/JwtService";
import Multiselect from '@vueform/multiselect';
import { Field } from "vee-validate";
import axios from 'axios';

export default defineComponent({
  name: "ListePlace",
  components: {
    PaginationComponent,
    Multiselect,
    Field,
  },
  setup() {
    onMounted(() => {
      getAllPlaces();
      getAllCategorieActivites();
      getAllMarches();
      getAllTypes();
    });
    const places = ref<Array<Place>>([]);
    const place = ref<Place>();
    const searchTerm = ref('');
    const page = ref(1);
    const totalPages = ref(0);
    const limit = ref(10);
    const totalElements = ref(0);
    const _marche = ref('');
    const _categorie = ref('');
    const _type = ref('');
    const _statut = ref('');
    const typeOptions = ref();
    const categorieActiviteOptions = ref();

    const marchementSelected = ref('');
    const marcheSelected = ref(0);
    const marchesOptions = ref([]);

    const typementSelected = ref('');
    const typeSelected = ref(0);
    const typesOptions = ref([]);

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";

    const fetchMarches = async (key) => {
      try {
        marcheSelected.value = parseInt(marchementSelected.value.split('-')[1]);
        const response = await axios.get(`/marches/recherche/${key}?marcheSelected=${marcheSelected.value}`);
        const marchesData = response.data.data;
        marchesOptions.value = marchesData.map((marche) => ({
          value: marche.id,
          label: marche.libelle,
        }));
        return marchesOptions.value;
      } catch (error) {
        //
      }
    }

    const fetchTypes = async (key) => {
      try {
        typeSelected.value = parseInt(typementSelected.value.split('-')[1]);
        const response = await axios.get(`/types/recherche/${key}?typeSelected=${typeSelected.value}`);
        const typesData = response.data.data;
        typesOptions.value = typesData.map((type) => ({
          value: type.id,
          label: type.libelle,
        }));
        return typesOptions.value;
      } catch (error) {
        //
      }
    }

    const handlePaginate = async ({ page_, limit_ }) => {
      try {
        page.value = page_;
        limit.value = limit_;
        await rechercher()
      } catch (error) {
        //
      }
    };
    function rechercher() {
      getAllPlaces(page.value, limit.value, searchTerm.value, _marche.value, _type.value, _categorie.value, _statut.value)
    }

    function getAllPlaces(page = 1, limi = 10, searchTerm = '', _marche = '', _type = '', _categorie = '', _statut = "") {
      return ApiService.get(`all/places?page=${page}&limit=${limi}&categorieActivite=${_categorie}&type=${_type}&marche=${_marche}&statut=${_statut}&mot=${searchTerm}&`)
        .then(({ data }) => {
          places.value = data.data.data;
          totalPages.value = data.data.totalPages;
          limit.value = data.data.limit;
          totalElements.value = data.data.totalElements;
          console.log('dataNouveau', data.data);
          return data.data;
        })
        .catch(({ response }) => {
          error(response.data.message);
        });
    }
    watch(_categorie, () => {
      rechercher();
    });

    watch(_type, () => {
      rechercher();
    });

    watch(_marche, () => {
      rechercher();
    });

    watch(_statut, (newVal) => {
      if (newVal === undefined || newVal === null || newVal === '') {
        _statut.value = '';
        rechercher();
      } else {
        rechercher();
      }
    });


    function moddifier(Editplaces: Place) {
      place.value = Editplaces;
    }
    const getAllMarches = async () => {
      try {
        const response = await ApiService.get('/all/marche');
        const marchesData = response.data.data.data;
        console.log('Data', marchesData)
        marchesOptions.value = marchesData.map((marche) => ({
          value: marche.id,
          label: marche.libelle,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }
    const getAllTypes = async () => {
      try {
        const response = await ApiService.get('/all/type');
        const typesData = response.data.data.data;
        console.log('Data', typesData)
        typesOptions.value = typesData.map((type) => ({
          value: type.id,
          label: type.libelle,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }
    const getAllCategorieActivites = async () => {
      try {
        const response = await ApiService.get('all/categorieActivites');
        const categorieActivitesData = response.data.data.data;
        console.log('Data', categorieActivitesData)
        categorieActiviteOptions.value = categorieActivitesData.map((categorieActivite) => ({
          value: categorieActivite.id,
          label: categorieActivite.libelle,
        }));
      }
      catch (error) {
        //error(response.data.message)
      }
    }
    const deletePlace = (id: number) => {
      ApiService.delete(`/places/${id}`)
        .then(({ data }) => {
          Swal.fire({
            text: data.message,
            toast: true,
            icon: 'success',
            title: 'General Title',
            animation: false,
            position: 'top-right',
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            heightAuto: false
          });
        })
        .catch(({ response }) => {
          Swal.fire({
            text: response.data.message,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Réssayer à nouveau!",
            heightAuto: false,
            customClass: {
              confirmButton: "btn fw-semobold btn-light-danger",
            },
          });
        });

      for (let i = 0; i < places.value.length; i++) {
        if (places.value[i].id === id) {
          places.value.splice(i, 1);
        }
      }
    };
    const privileges = ref<Array<string>>(JwtService.getPrivilege());
    const checkPermission = (name) => {
      return privileges.value.includes(name);
    }
    return {
      places,
      checkPermission,
      getAllPlaces,
      deletePlace,
      moddifier,
      suppression,
      page,
      totalPages,
      limit,
      totalElements,
      handlePaginate,
      rechercher,
      searchTerm,
      categorieActiviteOptions,
      marchesOptions,
      typesOptions,
      _marche,
      _categorie,
      _type,
      _statut,
      fetchMarches,
      fetchTypes,
      marcheSelected,
      typeSelected,
    };
  },
});
</script>